'use strict';
var app = {};
import initDropdown from './dropdown';
import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';

/**
 * Navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
(function () {
    var container, button, menu, links, i, len;

    container = document.getElementById('site-navigation');
    if (!container) {
        return;
    }

    button = container.getElementsByTagName('button')[0];
    if ('undefined' === typeof button) {
        return;
    }

    menu = container.getElementsByTagName('ul')[0];

    // Hide menu toggle button if menu is empty and return early.
    if ('undefined' === typeof menu) {
        button.style.display = 'none';
        return;
    }

    menu.setAttribute('aria-expanded', 'false');
    if (-1 === menu.className.indexOf('nav-menu')) {
        menu.className += ' nav-menu';
    }

    button.onclick = function () {
        if (-1 !== container.className.indexOf('toggled')) {
            container.className = container.className.replace(' toggled', '');
            button.setAttribute('aria-expanded', 'false');
            menu.setAttribute('aria-expanded', 'false');
        } else {
            container.className += ' toggled';
            button.setAttribute('aria-expanded', 'true');
            menu.setAttribute('aria-expanded', 'true');
        }
    };

    // Get all the link elements within the menu.
    links = menu.getElementsByTagName('a');

    // Each time a menu link is focused or blurred, toggle focus.
    for (i = 0, len = links.length; i < len; i++) {
        links[i].addEventListener('focus', toggleFocus, true);
        links[i].addEventListener('blur', toggleFocus, true);
    }

    /**
     * Sets or removes .focus class on an element.
     */
    function toggleFocus() {
        var self = this;

        // Move up through the ancestors of the current link until we hit .nav-menu.
        while (-1 === self.className.indexOf('nav-menu')) {

            // On li elements toggle the class .focus.
            if ('li' === self.tagName.toLowerCase()) {
                if (-1 !== self.className.indexOf('focus')) {
                    self.className = self.className.replace(' focus', '');
                } else {
                    self.className += ' focus';
                }
            }

            self = self.parentElement;
        }
    }

    /**
     * Toggles `focus` class to allow submenu access on tablets.
     */
    (function (container) {
        var touchStartFn, i,
            parentLink = container.querySelectorAll('.menu-item-has-children > a, .page_item_has_children > a');

        if ('ontouchstart' in window) {
            touchStartFn = function (e) {
                var menuItem = this.parentNode, i;

                if (!menuItem.classList.contains('focus')) {
                    e.preventDefault();
                    for (i = 0; i < menuItem.parentNode.children.length; ++i) {
                        if (menuItem === menuItem.parentNode.children[i]) {
                            continue;
                        }
                        menuItem.parentNode.children[i].classList.remove('focus');
                    }
                    menuItem.classList.add('focus');
                } else {
                    menuItem.classList.remove('focus');
                }
            };

            for (i = 0; i < parentLink.length; ++i) {
                parentLink[i].addEventListener('touchstart', touchStartFn, false);
            }
        }
    }(container));
})();

; (function ($) {
    var $doc = $(document);
    /** [1] */
    $.readyFn = {
        list: [],
        register: function (fn) {
            //console.log('Module Registered');

            $.readyFn.list.push(fn);
        },
        execute: function () {
            //console.log('Modules Executing');

            for (var i = 0; i < $.readyFn.list.length; i++) {
                try {
                    $.readyFn.list[i].apply(document, [$]);
                } catch (e) {
                    throw e;
                }
            }
        }
    };

    /** [2] */
    app = {
        // initMenus: function () {
        //     alert('initMenus');
        // },
        initCarousel: function () {

            //console.log('Module Executed: Carousel');

            // SLIDER HOME
            if (window.matchMedia("(max-width: 795px)").matches) {
                console.log($('.twitter'));
                $('div.twitter').find('.latest-tweets ul').addClass("owl-carousel");
            }

            $('.owl-carousel').on('initialized.owl.carousel', function (event) {
                $(".owl-item.active").addClass('new-active');
            })

            $('.owl-carousel').owlCarousel({
                center: true,
                items: 1,
                nav: true,
                navText: ["<span><</span>", "NEXT SDGs<span>></span>"],
                dots: true,
                loop: true,
                margin: 0,
                dotsContainer: '.categories',
                autoplay: false,
                autoplayTimeout: 1000,
                smartSpeed: 1000,
                dotSpeed: 1000,
                navSpeed: 1000,
                dragEndSpeed: 1000,
                cssEase: 'ease'
            });

            $('.owl-carousel').on('translate.owl.carousel', function (event) {
                $(".owl-item").removeClass('new-active');
            })

            $('.owl-carousel').on('translated.owl.carousel', function (event) {
                var current = event.item.index;
                $(".owl-item").eq(current).addClass('new-active');
            })


            $('div.twitter .owl-carousel').owlCarousel({
                center: true,
                items: 1,
                nav: true,
                navText: ["previous", "next <span>></span>"],
                loop: true,
                margin: 0,
                autoWidth: true
            });
        },
        initTabs: function () {
            //console.log('Module Executed: Tabs');

            // TABS NEWS HOME
            $("#news_tabs").tabs({
                active: 0
            });
        },
        initMainNav: function () {
            //console.log('Module Executed: Main Nav');

            if ($(window).width() > 1200 && $('.megamenu_items')) {
                $('.megamenu_has-sub').hover(function () {
                    target = $(this);
                    setTimeout(function () { $('.megamenu_items').addClass('hvr'); }, 200);
                    setTimeout(function () { $(target).addClass('hvr'); }, 200);
                },
                    function () {
                        setTimeout(function () { $('.megamenu_has-sub').removeClass('hvr'); }, 0);
                        setTimeout(function () { $('.megamenu_items').removeClass('hvr'); }, 0);
                    }
                );
            }
        },
        initStickyNav: function () {
            //console.log('Module Executed: Sticky Nav');

            if ($('.header_content').length > 0 && window.matchMedia("(min-width: 767px)").matches) {
                var lastScrollTop = 0,
                    scroll = $(window).scrollTop(),
                    headerHeight = $('.header_content').height(),
                    headerBottomPos = $('.header_content').offset().top + headerHeight;

                $(window).scroll(function () {
                    scroll = $(window).scrollTop();
                    if (scroll > headerBottomPos) {
                        $('.header_content').addClass('stickynav');
                        if (scroll > lastScrollTop && !$('body').hasClass('noscroll')) {
                            // Scroll Down
                            $('.header_content').removeClass('active');
                            $('.header_content').removeClass('home-search');
                            setTimeout(function () { $('.header_content').removeClass('transition'); }, 300);
                            $('.mod_filters-nav').removeClass('pushed');
                        } else {
                            // Scroll Up
                            if (scroll + $(window).height() < $(document).height()) {
                                $('.header_content').addClass('active');
                                $('.header_content').addClass('transition');
                                $('.mod_filters-nav.stickynav').addClass('pushed');
                            }
                        }
                    } else {
                        $('.mod_filters-nav').removeClass('pushed');
                        $('.header_content').removeClass('stickynav');
                        $('.header_content').removeClass('transition');
                        $('.header_content').removeClass('active');
                        $('.header_content').removeClass('home-search');
                    }
                    lastScrollTop = scroll;
                });
            }
        },
        initBurgerMenu: function () {
            //console.log('Module Executed: Burger Menu');

            $('header .burger_icon').click(function () {
                $('body').toggleClass('noscroll');
                $(this).toggleClass('active');
                $('header .megamenu-content').toggleClass('open');
            });

            $('header .megamenu_items .megamenu_has-sub .megamenu_item-link').click(function (e) {
                e.preventDefault();
                $(this).parent().find('.megamenu_sub').toggleClass('open');
            });
        },
        initMobileNewsSelect: function () {
            //console.log('Module Executed: Mobile News Select');

            $('.news_events .mob_select_wrapper .mob_select').on('change', function () {
                var selectValue = $(this).val();
                $('.news_events .tabs_nav li a').filter(function () {
                    return $(this).text() === selectValue;
                }).trigger('click');
            });
        },

        initNewsExpand: function () {
            //console.log('Module Executed: News Expand');
            /*
            $('.page-template-news .all_news .news_wrapper .news_content').accordion({
                active: false,
                collapsible: true,
                heightStyle: "content"
            });

            if($('body').hasClass('page-template-news')) {

              var url = window.location.href;
              var hash = url.substring(url.indexOf("#")+1);
              var hashbis = $(location).attr('hash');

              if (hashbis) {
                $(hashbis).click();
              }
            }
            */
            if ($('.page-template-news .all_news').length) {
                $('.page-template-news .all_news .news_wrapper .post').on('click', function () {
                    location.href = $(this).find('a.expander').attr('href');
                });
            }

        },
        initNewsSticky: function () {
            //console.log('Module Executed: News Sticky');

            if ($('.page-template-news').length) {

                var stickyTop = $('.page-template-news .all_news .col:first-child .col-wrapper').offset().top - 150,
                    title = $('.page-template-news .all_news .col:first-child .col-wrapper'),
                    content = $('.page-template-news .all_news .col:last-child');

                $(window).scroll(function () {
                    if (window.matchMedia("(min-width: 767px)").matches) {
                        var windowTop = $(window).scrollTop();
                        if (stickyTop < windowTop && content.height() + content.offset().top - (title.height() + 150) > windowTop) {
                            title.addClass('fixed');
                            title.removeClass('stopped');
                        } else if (stickyTop > windowTop && content.height() + content.offset().top - (title.height() + 150) > windowTop) {
                            title.removeClass('fixed');
                            title.removeClass('stopped');
                        } else {
                            title.removeClass('fixed');
                            title.addClass('stopped');
                        }
                    } else {
                        title.removeClass('fixed');
                    }
                });
            }
        },
        initSearchWindow: function () {
            //console.log('Module Executed: Search Window');

            if ($(window).width() > 1200) {
                $('header .megamenu_search').click(function (e) {
                    e.preventDefault();
                    if (!$('header .search_window').hasClass('active') && !$('header .header_content').hasClass('stickynav') && $('body').hasClass('home')) {
                        $('header .search_window').addClass('active');
                        $('body').addClass('noscroll');
                        $('header .header_content').addClass('stickynav active transition home-search');
                    } else if ($('header .search_window').hasClass('active')) {
                        $('header .search_window').removeClass('active');
                        $('body').removeClass('noscroll');
                        $('header .header_content').removeClass('stickynav active transition home-search');
                    } else {
                        $('header .search_window').addClass('active');
                        $('body').addClass('noscroll');
                        $('header .header_content').addClass('stickynav active transition');
                    }
                });

                $('header .search_window .wrapper .close').click(function (e) {
                    e.preventDefault();
                    $('header .search_window').removeClass('active');
                    $('body').removeClass('noscroll');
                    $('header .header_content').removeClass('stickynav active transition home-search');
                });
            }
        },
        initShareLinkedin: function () {
            if ($('a[title="linkedin"]').length) {
                $('a[title="linkedin"]').click(function () {
                    var w = 500;
                    var h = 600;
                    var left = (screen.width / 2) - (w / 2);
                    var top = (screen.height / 2) - (h / 2);
                    window.open($(this).attr('href'), 'mywindow', 'menubar=1,resizable=1,width=' + w + ',height=' + h + ',left=' + left + ',top=' + top);
                    return false;
                });
            }
        },
        initCountdown: function () {
            const countdowns = document.querySelectorAll('.js-countdown');
            countdowns.forEach(countdown => {
                const dataFinalDate = countdown.dataset.countdownDate;
                const deadline = new Date(dataFinalDate + " 00:00:00").getTime();
                const daysContainer = countdown.querySelector('.countdown-date-days');
                const hoursContainer = countdown.querySelector('.countdown-date-hours');
                const minutesContainer = countdown.querySelector('.countdown-date-minutes');
                const x = setInterval(function () {
                    const now = new Date().getTime();
                    const t = deadline - now;
                    const days = Math.floor(t / (1000 * 60 * 60 * 24));
                    const hours = Math.floor((t % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    const minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60));
                    daysContainer.innerHTML = days;
                    hoursContainer.innerHTML = hours;
                    minutesContainer.innerHTML = minutes;
                    if (t < 0) {
                        clearInterval(x);
                        daysContainer.innerHTML = "0";
                        hoursContainer.innerHTML = "0";
                        minutesContainer.innerHTML = "0";
                    }
                }, 1000);
            });
        },

        // Cop 27 & Cop 28 landing pages

        initLandingPage: function () {
            const $page = document.querySelector('[class*="landing-page-cop"]');

            if ($page) {
                const filterParams = new Map();

                // injecte du html dans le bloc de remontées twitter
                const initTwitterBlock = () => {
                    const $twitterBlock = $page.querySelector('.latest-tweets');

                    if ($twitterBlock) {
                        const $twitterItems = $twitterBlock.querySelectorAll('li');

                        $twitterItems.forEach((item) => {

                            const title = document.createElement("div");
                            title.classList.add('title');
                            title.textContent = 'Twitter';

                            const author = document.createElement("div");
                            author.classList.add('author');
                            author.textContent = 'International Development Finance Club';

                            const authorSub = document.createElement("div");
                            authorSub.classList.add('author-sub');
                            authorSub.textContent = '@IDFC_Network';

                            item.prepend(title, author, authorSub);
                        })
                    }
                }

                const initFiltersEvents = () => {
                    const $filters = $page.querySelectorAll('[data-filter]');

                    $filters.forEach((filter) => {
                        const radios = filter.querySelectorAll('input');
                        const deleteBtn = filter.querySelector('.delete');
                        const filterBtn = filter.querySelector('.filter-button');
                        const filterType = filter.dataset.filter;

                        radios.forEach((radio) => {
                            radio.addEventListener('change', () => {
                                updateFilter(filterType, radio.value);
                                filterBtn.classList.add('active');
                            });
                        });

                        deleteBtn.addEventListener('click', () => {
                            radios.forEach((radio) => {
                                radio.checked = false;
                            });
                            filterBtn.classList.remove('active');
                            deleteFilter(filterType);
                        })
                    });
                }

                const updateFilter = (type, value) => {
                    filterParams.set(type, value);
                    if (type == 'week') {
                        updateFilterDay();
                    }
                    updateDisplayEvent();
                }

                const deleteFilter = (type) => {
                    filterParams.delete(type);
                    if (type == 'week') {
                        updateFilterDay();
                    }
                    updateDisplayEvent();
                }

                const updateFilterDay = () => {
                    const $filtersDay = $page.querySelectorAll('[data-day-week]');
                    if (filterParams.get('week')) {
                        $filtersDay.forEach((filter) => {
                            filter.classList.add('hidden');
                            if (filterParams.get('week') == filter.dataset.dayWeek) {
                                filter.classList.remove('hidden');
                            }
                        });
                    } else {
                        $filtersDay.forEach((filter) => {
                            filter.classList.remove('hidden');
                        });
                    }
                }

                const updateDisplayEvent = () => {
                    const $wrapperEvents = $page.querySelector('.wrapper-events');
                    const eventsLp = $page.querySelectorAll('.js-event');
                    let nbEventsDisplay = 0;
                    const noEvents = $page.querySelector('.no-event');
                    eventsLp.forEach((eventLp) => {
                        eventLp.classList.add('hidden');
                        let matchEventFilter = 0;
                        for (var [key, value] of filterParams) {
                            if (eventLp.dataset[key] === value) {
                                matchEventFilter++;
                            }
                        }
                        if (matchEventFilter === filterParams.size) {
                            eventLp.classList.remove('hidden');
                            nbEventsDisplay++;
                        }
                    });

                    if (nbEventsDisplay == 0) {
                        noEvents.classList.remove('hidden');
                    } else {
                        noEvents.classList.add('hidden');
                    }

                    if (filterParams.size > 0) {
                        $wrapperEvents.classList.add('filter-active');
                    } else {
                        $wrapperEvents.classList.remove('filter-active');

                    }
                }

                const initLoadMoreEvents = () => {
                    const $btnLoadMore = $page.querySelector('.js-load-more');
                    const $eventsHiddenMore = $page.querySelectorAll('.js-event.hidden-more')
                    if ($btnLoadMore) {
                        $btnLoadMore.addEventListener('click', (el) => {
                            if ($eventsHiddenMore) {
                                $eventsHiddenMore.forEach((item) => {
                                    item.classList.remove('hidden-more');
                                });
                            }
                            $btnLoadMore.classList.add('hidden');
                        });
                    }
                }

                const initShowMoreEvent = () => {
                    const $btnsShowMore = $page.querySelectorAll('.js-show-more');
                    $btnsShowMore.forEach((btn) => {
                        btn.addEventListener('click', (el) => {
                            const event = el.target.parentNode.parentNode;
                            event.classList.toggle('expand');
                            el.preventDefault();
                        });
                    });
                }

                const initExpandBlockDocuments = () => {
                    const $btnsExpandBlockDocuments = $page.querySelectorAll('.js-expand-block-documents');
                    $btnsExpandBlockDocuments.forEach((btn) => {
                        btn.addEventListener('click', (el) => {
                            const blockDocuments = el.target.parentNode;
                            blockDocuments.classList.toggle('expand');
                            el.preventDefault();
                        });
                    });
                }

                const initDDayTriggerFilter = () => {
                    const initialDay = 6;
                    const initialMonth = 11;
                    const dDayDate = new Date();
                    const dDayDateDay = dDayDate.getDate();
                    const dDayDateMonth = dDayDate.getMonth() + 1;

                    if (dDayDateMonth == initialMonth && dDayDateDay >= initialDay) {
                        const numberInput = (dDayDateDay - initialDay) + 1;
                        const inputDDay = $page.querySelector('#day' + numberInput);
                        if (inputDDay) {
                            inputDDay.click();

                        }
                    }
                }

                initTwitterBlock();
                initFiltersEvents();
                initLoadMoreEvents();
                initShowMoreEvent();
                initExpandBlockDocuments();
                initDDayTriggerFilter();

                // Gestion nav sticky sur landing cop 28
                if (document.querySelector('[class*="landing-page-cop28"]') || document.querySelector('[class*="landing-page-cop29"]')) {
                    const initStickyNavigation = () => {
                        if (window.pageYOffset > 10) {
                            document.querySelector('.header-landing-page').classList.add('navigation--sticky');
                            document.querySelector('html').classList.add('navigation--is-sticky');
                        } else {
                            document.querySelector('.header-landing-page').classList.remove('navigation--sticky');
                            document.querySelector('html').classList.remove('navigation--is-sticky');
                        }
                    }

                    initStickyNavigation();

                    window.addEventListener('scroll', () => {
                        initStickyNavigation();
                    });

                }

                const initStickyVideo = () => {
                    const $videoWrapper = $video.querySelector('.video-subwrapper')
                    document.addEventListener('scroll', () => {
                        const bodyRect = document.body.getBoundingClientRect();
                        let videoRect = $video.getBoundingClientRect();
                        let offset = videoRect.bottom - bodyRect.top;

                        if (offset < window.scrollY) {
                            $videoWrapper.classList.add('sticky');
                        }

                        else if (offset > window.scrollY) {
                            $videoWrapper.classList.remove('sticky');
                        }
                    })
                }

                const $video = $page.querySelector('.video--live-active');

                if ($page.querySelector('.video--live-active')) {
                    window.addEventListener('resize', () => {
                        if (window.innerWidth > 768) {
                            initStickyVideo();
                        }
                    })

                    window.addEventListener('DOMContentLoaded', () => {
                        if (window.innerWidth > 768) {
                            initStickyVideo();
                        }
                    })
                }
            }
        },

        initBandeauPushNews() {
            const $bandeauPushNews = document.querySelector('.bandeau_push_news');
            const $body = document.querySelector('body');
            if ($bandeauPushNews) {
                $closeBtn = $bandeauPushNews.querySelector('.close');

                $closeBtn.addEventListener('click', () => {
                    $bandeauPushNews.classList.remove('visible');
                    $body.classList.add('bandeau_push_news_active_disable');

                    const d = new Date();
                    d.setTime(d.getTime() + (1 * 24 * 60 * 60 * 1000));
                    const expires = 'expires=' + d.toUTCString();
                    document.cookie = 'bandeau_push_news=1;' + expires;
                });

                const cookies = document.cookie.split('; ');
                for (let i = 0; i < cookies.length; i++) {
                    const c = cookies[i].split('=');
                    if (c[0] === 'bandeau_push_news') {
                        $bandeauPushNews.classList.remove('visible');
                        $body.classList.add('bandeau_push_news_active_disable');
                    }
                }
            }
        },

        initPublicationsList() {
            const $publicationsList = document.querySelector('.page-template-publications .publications-results');

            if ($publicationsList) {
                console.log($publicationsList.querySelector('.filters-form'));
                const $formFilter = $publicationsList.querySelector('.filters-form');
                const $btnResetFilter = $publicationsList.querySelector('.js-reset-filter');
                const $btnSubmit = $publicationsList.querySelector('.js-submit-form');

                const $allFiltersInput = $publicationsList.querySelectorAll('.filters-form-input input:not([name="input-order"])');
                const $allSortInput = $publicationsList.querySelectorAll('.filters-form-input input[name="input-order"]');

                const $megamenu = document.querySelector('.megamenu');

                const $publicationsResultsList = $publicationsList.querySelector('.publications-results-list');
                const $publicationsPagination = $publicationsList.querySelector('.publications-results-pagination');

                // Reset filter
                if ($btnResetFilter) {
                    $btnResetFilter.addEventListener('click', () => {
                        $allFiltersInput.forEach((input) => {
                            input.checked = false;
                        });

                        $allSortInput.forEach((input) => {
                            input.checked = (input.dataset.default == 'true' ?? false);
                        });

                        $btnSubmit.click();
                    });
                }

                document.addEventListener('click', (evt) => {
                    // Check filter delete
                    // On cherche sur le document click car les items peuvent être injectés en ajax

                    if (evt.target.classList.contains('js-check-filter-delete')) {
                        evt.preventDefault();
                        const check = evt.target;

                        const id = check.dataset.inputId;
                        $allFiltersInput.forEach((input) => {
                            if (input.id == id) {
                                input.checked = false;
                            }
                        });

                        check.parentNode.remove();
                        $btnSubmit.click();
                    }

                    if (evt.target.classList.contains('page-numbers')) {
                        evt.preventDefault();

                        ajaxCall(evt.target.getAttribute('href'));
                    }
                });

                // Ajax submit
                $formFilter.addEventListener('submit', (event) => {
                    event.preventDefault();
                    const data = event.target;
                    const formData = new FormData(data);
                    const urlParams = new URLSearchParams(formData);

                    const url = data.getAttribute('action') + '?' + urlParams.toString();

                    ajaxCall(url);
                });

                // Ajax call
                const ajaxCall = function (url) {
                    fetch(url, {
                        method: 'GET',
                    })

                        .then(res => res.text())
                        .then(function (data) {
                            const response_html = document.createElement('div');
                            response_html.innerHTML = data;

                            const results_list = response_html.querySelector('.publications-results-list');
                            const results_pagination = response_html.querySelector('.publications-results-pagination');

                            $publicationsResultsList.innerHTML = results_list.outerHTML;
                            $publicationsPagination.innerHTML = results_pagination.outerHTML;

                            window.history.pushState({}, false, url);
                            let scrollToPos = $publicationsResultsList.getBoundingClientRect().top + window.scrollY - 15;
                            if (window.matchMedia("(min-width: 768px)").matches) {
                                scrollToPos -= $megamenu.offsetHeight + 15;
                            }


                            scrollTo(scrollToPos);
                        });
                };

                scrollTo = function ($element, smooth = true) {
                    const posY = typeof $element === 'number' ? $element : $element.getBoundingClientRect().top + window.scrollY;

                    if (!smooth) {
                        // Supprime la propriété CSS "scrollBehavior"
                        document.documentElement.style.scrollBehavior = 'initial';
                        document.body.style.scrollBehavior = 'initial';
                    }

                    window.scroll(0, posY);

                    if (!smooth) {
                        // Reset de la propriété CSS "scrollBehavior"
                        document.documentElement.style.scrollBehavior = '';
                        document.body.style.scrollBehavior = '';
                    }

                    return self;
                };
            }
        },

        initSliderMembres: function () {
            let swiper = new Swiper('.js-liste-membres-slider', {
                modules: [Autoplay],
                spaceBetween: 0,
                centeredSlides: true,
                speed: 6000,
                autoplay: {
                    delay: 0,
                },
                loop: true,
                slidesPerView: 'auto',
                allowTouchMove: false,
                disableOnInteraction: true
            });
        },

        initSliderHome: function () {
            let swiper = new Swiper('.js-slider-home-cartes', {
                modules: [Navigation],
                spaceBetween: 20,
                // slidesOffsetBefore: 20,
                slidesPerView: 'auto',
                allowTouchMove: true,
                disableOnInteraction: true,
                navigation: {
                    prevEl: ".js-slider-home-prev",
                    nextEl: ".js-slider-home-next",
                },
                breakpoints: {
                    640: {
                        spaceBetween: 24,
                        slidesOffsetBefore: -80,
                    },
                }
            });
        },


        initTabsHome: function () {
            const tabsWrapper = document.querySelector('.js-news-agenda-tabs');

            if (tabsWrapper) {
                const tabs = [...tabsWrapper.querySelectorAll('.tab')]

                tabs.forEach(tab => tab.addEventListener("click", tabsAnimation))

                const tabContents = [...tabsWrapper.querySelectorAll(".tab-content")]

                function tabsAnimation(e) {

                    const indexToRemove = tabs.findIndex(tab => tab.classList.contains("active-tab"))
                    tabs[indexToRemove].classList.remove("active-tab");
                    tabContents[indexToRemove].classList.remove("active-tab-content");

                    const indexToShow = tabs.indexOf(e.target)
                    tabs[indexToShow].classList.add("active-tab")
                    tabContents[indexToShow].classList.add("active-tab-content")
                }
            }

            let swiper = new Swiper('.js-news-agenda-swiper-actus', {
                modules: [Navigation],
                spaceBetween: 28,
                slidesPerView: 'auto',
                allowTouchMove: true,
                disableOnInteraction: true,
                navigation: {
                    prevEl: ".js-news-agenda-swiper-actus-prev",
                    nextEl: ".js-news-agenda-swiper-actus-next",
                },
            });

            let swiper2 = new Swiper('.js-news-agenda-swiper-events', {
                modules: [Navigation],
                spaceBetween: 28,
                slidesPerView: 'auto',
                allowTouchMove: true,
                disableOnInteraction: true,
                navigation: {
                    prevEl: ".js-news-agenda-swiper-events-prev",
                    nextEl: ".js-news-agenda-swiper-events-next",
                },
            });

        }
    };

    /** [3] */
    $doc.ready(function () {
        //console.log('Initial Document Ready');

        $.readyFn.execute();
    });

    /** [4] */
    $.fn.ready = $.readyFn.register;

})
    ($);

/** [5] */
$(function () {

    // Agenda
    if ($('body').hasClass('page-template-agenda')) {
        var firstload = false;
        var currentday = moment().format('YYYY-MM-DD');

        // Grid View
        function strpos(haystack, needle, offset) {
            var i = (haystack + '').indexOf(needle, (offset || 0));
            return i === -1 ? false : i;
        }

        function formatDate(date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;

            return [year, month, day].join('-');
        }

        function formatHour(date) {
            var d = new Date(date),
                hours = d.getHours();

            var ampm = hours >= 12 ? 'pm' : 'am',
                hours = hours % 12,
                hours = hours ? hours : 12;

            return hours + ' ' + ampm;
        }


        $('div.calendrier').fullCalendar({
            header: false,
            height: 1000,
            locale: 'fr',
            navLinks: false, // can click day/week names to navigate views
            businessHours: false, // display business hours
            editable: false,
            nowIndicator: false,
            /*dayNamesShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],*/
            columnHeaderFormat: 'dddd',
            events: events,
            displayEventTime: true,
            eventClick: function (event) {
                if (event.url) {
                    window.open(event.url);
                    return false;
                }
            },
            eventRender: function (event, element, view) {
                /* if (event.nbEvents == 1) $(element).find('.fc-content').html('<span class="title">' + event.title_full + '</span><span class="date">' + formatHour(event.start) + '</span>');
                else $(element).find('.fc-content').html('<span class="title">' + event.title_full + '</span><span class="date">' + formatHour(event.start) + '</span>'); */
                $(element).find('.fc-content').html('<span class="title">' + event.title_full + '</span><span class="date">' + formatHour(event.start) + '</span>');
                $(element).attr('data-date', formatDate(event.start));
                $(element).attr('data-cat', event.categorie_slug);
                var eventStartTime = event.start._i.split('T');
                eventStartTime = eventStartTime[1];
                var eventEndTime = event.end._i.split('T');
                eventEndTime = eventEndTime[1];
                if (eventStartTime === "00:00:00" && eventEndTime === "23:59:00") {
                    $(element).addClass('fullday');
                }
            },
            eventAfterRender: function (event, element, view) {
                if (event.isStickied) {
                    $('td[data-date="' + formatDate(event.start) + '"]').addClass('closed');
                    $('.fc-event[data-date="' + formatDate(event.start) + '"]').addClass('closed');
                    $(element).html('<span>' + event.title + '</span>');
                }
            },
            viewRender: function (view, element) {
                $('.fc-row .fc-other-month.fc-past').each(function (id, ele) {
                    $(ele).parents('table').find('tbody td:eq(' + $(ele).index() + ')').addClass('fc-other-month');
                });
                $('.fc-row .fc-content-skeleton .fc-other-month').each(function (id, ele) {
                    $(ele).parents('table').find('tbody td:eq(' + $(ele).index() + ')').addClass('fc-other-month');
                });
                //$('.fc-widget-content.fc-today').append('<span class="bordure"></span>');

                // Grid
                var _moment = moment(view.calendar.currentDate._d);
                _moment.locale('fr');
                $('.header-calendrier .month').html(_moment.format('MMMM YYYY'));

                var next_month = _moment.clone().add(1, 'months');
                /* $('.header-calendrier .next').html(next_month.format('MMMM YYYY')); */
                $('.header-calendrier .next,.agenda-search.mobile .month .next').attr('data-date', next_month.format('YYYY-MM-DD'));
                var prev_month = _moment.clone().subtract(1, 'months');
                /* $('.header-calendrier .prev').html(prev_month.format('MMMM YYYY')); */

                $('.agenda-search.mobile .month .title').html(_moment.format('MMMM'));

                // Cache les mois antérieurs à la date du jour
                var today = new Date();
                if (prev_month.format('YYYYMM') < moment(today).format('YYYYMM')) $('.header-calendrier .prev,.agenda-search.mobile .month .prev').addClass('disabled');
                else $('.header-calendrier .prev,.agenda-search.mobile .month .prev').removeClass('disabled');

                // Filtres
                filtersAgenda();
                $('.page-template-agenda .agenda .header-calendrier .calendrier_nav-wrapper .filters_popin .body .bottom input[type=submit]').click(function (e) {
                    e.preventDefault();
                    filtersAgenda();
                })

                if (events !== null) {
                    // Class sur les cellules qui possèdent un evènement
                    for (var i = 0; i < events.length; i++) {
                        var evStartDate = new Date(events[i].start),
                            evFinishDate = new Date(events[i].end);
                        if (events[i].end) {
                            while (evStartDate <= evFinishDate) {
                                addClassByDate(evStartDate);
                                evStartDate.setDate(evStartDate.getDate() + 1);
                            }
                        } else {
                            addClassByDate(evStartDate);
                        }
                    }
                }

                function addClassByDate(date) {
                    var dataAttr = formatDate(date);
                    $("[data-date='" + dataAttr + "']").addClass("hasEvent");

                    // Changement couleur bordure jour
                    if (!$('thead td[data-date="' + dataAttr + '"]').attr('data-cat')) $('thead td[data-date="' + dataAttr + '"]').attr('data-cat', $('.fc-event[data-date="' + dataAttr + '"]').attr('data-cat'));
                    else $('thead td[data-date="' + dataAttr + '"]').attr('data-cat', 'both');

                    if (!$('.fc-bg td.fc-day[data-date="' + dataAttr + '"]').attr('data-cat')) $('.fc-bg td.fc-day[data-date="' + dataAttr + '"]').attr('data-cat', $('.fc-event[data-date="' + dataAttr + '"]').attr('data-cat'));
                    else $('.fc-bg td.fc-day[data-date="' + dataAttr + '"]').attr('data-cat', 'both');

                }

                var currentmoment = $('div.calendrier').fullCalendar('getDate');
                var currentmonth = (new Date(moment(currentmoment).format('YYYY-MM-DD')).getMonth()) + 1;

                $('.no-results').css('display', 'none');

                $('.page-template-agenda .agenda .list_view .days .events').empty();
                var currentmonthevents = $('.page-template-agenda .list_view .day.selectable[data-month="' + currentmonth + '"]').clone();
                $(currentmonthevents).appendTo('.page-template-agenda .agenda .list_view .days .events');

                if ($('.page-template-agenda .list_view .day[data-month="' + currentmonth + '"]').length < 1) {
                    $('.no-results').css('display', 'block');
                }
            }
        });

        $('.header-calendrier .prev,.agenda-search.mobile .month .prev').click(function () {
            $('div.calendrier').fullCalendar('prev');
            var currentmoment = $('div.calendrier').fullCalendar('getDate');
            var currentmonth = (new Date(moment(currentmoment).format('YYYY-MM-DD')).getMonth()) + 1;

            $('.no-results').css('display', 'none');

            $('.page-template-agenda .agenda .list_view .days .events').empty();
            var currentmonthevents = $('.page-template-agenda .list_view .day.selectable[data-month="' + currentmonth + '"]').clone();
            $(currentmonthevents).appendTo('.page-template-agenda .agenda .list_view .days .events');

            if ($('.page-template-agenda .list_view .day[data-month="' + currentmonth + '"]').length < 1) {
                $('.no-results').css('display', 'block');
            }

            $('#datepicker').datepicker('setDate', new Date(moment(currentmoment).format('YYYY-MM-DD')));
            return false;
        });
        $('.header-calendrier .next,.agenda-search.mobile .month .next').click(function () {
            $('div.calendrier').fullCalendar('next');
            var currentmoment = $('div.calendrier').fullCalendar('getDate');
            var currentmonth = (new Date(moment(currentmoment).format('YYYY-MM-DD')).getMonth()) + 1;

            $('.no-results').css('display', 'none');

            $('.page-template-agenda .agenda .list_view .days .events').empty();
            var currentmonthevents = $('.page-template-agenda .list_view .day.selectable[data-month="' + currentmonth + '"]').clone();
            $(currentmonthevents).appendTo('.page-template-agenda .agenda .list_view .days .events');

            if ($('.page-template-agenda .list_view .day[data-month="' + currentmonth + '"]').length < 1) {
                $('.no-results').css('display', 'block');
            }

            $('#datepicker').datepicker('setDate', new Date(moment(currentmoment).format('YYYY-MM-DD')));
            return false;
        });

    }

    var category_event;

    $('.page-template-agenda .agenda .header-calendrier .calendrier_nav-wrapper .filters_popin .body form').on('submit', function () {
        filtersAgenda();

        return false;
    });

    $('.page-template-agenda .agenda .header-calendrier .calendrier_nav-wrapper .filters_popin .body .bottom button').click(function (e) {
        // Reset du filtre catégorie
        e.preventDefault();
        $('.filters_nav .filter input').prop('checked', false);
        filtersAgenda();
    });

    function filtersAgenda() {

        /* $('.event:not(.closed)').show(); */

        category_event = [];

        if ($('.page-template-agenda .agenda .header-calendrier .calendrier_nav-wrapper .filters_popin .body form').find('input:checked').length) {
            $('.page-template-agenda .agenda .header-calendrier .calendrier_nav-wrapper .filters_popin .body form input').each(function (index, element) {
                if ($(this).prop('checked') == true) {
                    category_event.push($(this).val());
                }
            });
        }

        // Effacer tous les evenements de la vue calendrier
        $('.fc-event').attr('style', 'display:none !important');

        // Effacer tous les evenements de la vue calendrier
        var currentmonth = (new Date(moment($('div.calendrier').fullCalendar('getDate')).format('YYYY-MM-DD')).getMonth()) + 1;
        $('.page-template-agenda .agenda .list_view .days .events').empty();
        $('.page-template-agenda .list_view .day').removeClass('selectable');

        setTimeout(function () {
            // Afficher les evenements de la vue calendrier qui correspondent aux filtres
            if (category_event.length > 0 && $(window).width() > 795) {
                $(category_event).each(function (index, element) {
                    $(".fc-event").each(function (index2, element2) {
                        var currentIsOk = false;
                        var currentCat = $(element2).data("cat");
                        if (currentCat === element) {
                            $(this).attr('style', 'display:block !important');
                        }
                    });
                });
                // Afficher les evenements de la vue liste qui correspondent aux filtres
            } else if (category_event.length > 0 && $(window).width() <= 795) {
                $(category_event).each(function (index, element) {
                    $(".page-template-agenda .list_view .day").each(function (index2, element2) {
                        var currentIsOk = false;
                        var currentCat = $(element2).data("cat");
                        if (currentCat === element) {
                            $(this).addClass('selectable');
                        }
                    });
                });
                var currentmonthevents = $('.page-template-agenda .list_view .day.selectable[data-month="' + currentmonth + '"]').clone();
                $(currentmonthevents).appendTo('.page-template-agenda .agenda .list_view .days .events');
                if ($('.page-template-agenda .list_view .day.selectable[data-month="' + currentmonth + '"]').length < 1) {
                    $('.no-results').css('display', 'block');
                }
            } else {
                $('.fc-event').attr('style', 'display:block !important');
                $('.page-template-agenda .list_view .day').addClass('selectable');
                var currentmonthevents = $('.page-template-agenda .list_view .day.selectable[data-month="' + currentmonth + '"]').clone();
                $(currentmonthevents).appendTo('.page-template-agenda .agenda .list_view .days .events');
                if ($('.page-template-agenda .list_view .day.selectable[data-month="' + currentmonth + '"]').length < 1) {
                    $('.no-results').css('display', 'block');
                }
            }
        }, 1);

        /* $("html, body").animate({scrollTop:$('.page-template-agenda .agenda').position().top}, 400, 'swing', function() {}); */
    }

    $(window).scroll(function () {

    });

    $(window).resize(function () {

    });

    //init Global
    app.initCountdown();
    app.initCarousel();
    app.initTabs();
    app.initMainNav();
    // app.initStickyNav();
    app.initBurgerMenu();
    app.initMobileNewsSelect();
    app.initNewsExpand();
    app.initNewsSticky();
    app.initSearchWindow();
    app.initShareLinkedin();
    app.initSliderMembres();
    app.initSliderHome();
    initDropdown();
    app.initLandingPage()
    app.initBandeauPushNews();
    app.initPublicationsList();
    app.initTabsHome();
});

